export const environment = {
  production: false,
  publicApiUrl: "https://emkl0sqcjg.execute-api.us-east-1.amazonaws.com/dev/api/v1/public",
  secureApiUrl: "https://emkl0sqcjg.execute-api.us-east-1.amazonaws.com/dev/api/v1",
  yunoPublicKey: "sandbox_gAAAAABoejjDiIprQ6hW7RplHTWOisjB3nhORoFWqcyYS5nDOye0EKcN1xVVJDYTUyv0rJw1__fZT_1CV3H0v8UvvNIJUEDYepJkuVTT8urXSv9WB4sG3mh8oBISp4uAzKNhi3LvQUKlRThlQBZeC9Sw1XNbexPNDP-zhlf9X9NcPFLLAnp8zFcqIzSNY8dddEa1xVh2MhwNydJwp4dFZKbcizuFtDL8WB0NVG6wY425cI5rcFuU9RIhkzIu3DUq2B6vV3g1B8LO",
  esimProductCode: "cafe30a9-a69d-477c-92ad-0c0e3b210657",
  rechargeUrl: "https://devel.virginmobile.mx/v1/recarga",
  version: 1793395998945,
};
